export default "__VITE_ASSET__4be8a92b__"